





























import { Component, Vue, Prop } from 'vue-property-decorator'
import { GvdPage } from '@/store/modules/gvd'

@Component
export default class EditGvdPage extends Vue {
  @Prop() gvdPage!: GvdPage;

  saveChanges () {
    this.$bvModal
      .msgBoxConfirm('Are you sure you wish to save changes?', {
        size: 'sm',
        buttonSize: 'sm',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (!value) {
          return
        }
        this.$store.dispatch('saveGvdPage', this.gvdPage).then(() => {
          this.$bvModal.hide('edit-gvd-page-modal')
        })
      })
  }
}
